import { render } from "./Aggrid.vue?vue&type=template&id=b81fa41a&scoped=true"
import script from "./Aggrid.vue?vue&type=script&lang=js"
export * from "./Aggrid.vue?vue&type=script&lang=js"

import "./Aggrid.vue?vue&type=style&index=0&id=b81fa41a&lang=css"
import "./Aggrid.vue?vue&type=style&index=1&id=b81fa41a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81fa41a"]])

export default __exports__